module.exports = __webpack_public_path__ + "media/images/dollar-sign-c4354e9c.png";